export default "__VITE_ASSET__BB4XdjHn__"